import { Component } from '@angular/core';
import { AppConfigService } from '@core/app-config';
import { PromoLegalModalDialogComponent } from '@shared/promo-legal-modal-dialog';
import { JbDialogService } from 'jb-component-library';

import { Restriction } from '../promo-section-header/flight-block-container/types/restriction.type';
import { ProductBlockContainer } from '../promo-section-header/product-block-container/types/product-block-container.type';

@Component({
  selector: 'jb-isolated-product-block-container',
  templateUrl: './isolated-product-block-container.component.html',
})
export class IsolatedProductBlockContainerComponent {
  productBlock: ProductBlockContainer;
  enableLazyLoadImage: boolean;
  hasImageHeightWidthAttr = false;
  placeholderParams: string;

  constructor(
    public dialogService: JbDialogService,
    private appConfigService: AppConfigService,
  ) {
    this.enableLazyLoadImage = this.appConfigService.lazyLoadImages;
    this.hasImageHeightWidthAttr = this.appConfigService.imageHeightWidthAttr;
    this.placeholderParams =
      this.appConfigService.paths[0].placeholderImageParams;
  }

  openLegalDialog(event: Event, dialogData: Restriction[]): void {
    const componentRef: {
      handleData: (val: Restriction[]) => void;
    } = this.dialogService.openDialog(
      PromoLegalModalDialogComponent,
      event.target,
    );
    componentRef.handleData(dialogData);
  }
}

export const isolatedProductBlockContainerResolver = (registry, data) => ({
  productBlock: data.productBlock,
});
